import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { AgentContactInfosDto } from '@workspace/data-types';
import { UserStore } from '@workspace/ng-data-access';

@Component({
  selector: 'etxe-agent-contact-infos-display',
  imports: [MatIconModule],
  templateUrl: './agent-contact-infos-display.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentContactInfosDisplayComponent {
  private readonly userStore = inject(UserStore);

  readonly contactInfos = input<AgentContactInfosDto | undefined>(undefined);

  readonly showPhone = computed(() => this.contactInfos()?.showMobileNumber ?? true);
  readonly showEmail = computed(() => this.contactInfos()?.showEmail ?? true);

  readonly hasCustomPhone = computed(() => !!this.contactInfos()?.mobileNumber?.trim());
  readonly hasCustomEmail = computed(() => !!this.contactInfos()?.email?.trim());

  readonly phone = computed(() => this.contactInfos()?.mobileNumber?.trim() || null);
  readonly email = computed(() => this.contactInfos()?.email?.trim() || null);

  readonly defaultPhone = computed(
    () => this.userStore.currentUser()?.contactInfos?.mobileNumber?.trim() || null,
  );
  readonly defaultEmail = computed(() => this.userStore.currentUser()?.contactInfos?.email?.trim() || null);
}
